"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reduxForm = require("redux-form");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _Button = require("../form/Button");
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
var _FormItem = require("../form/FormItem");
var _NumberInput = require("../form/NumberInput");
var _table = require("../data/table");
var _numberFormatter = require("../../helpers/numberFormatter");
var _futuresPositionsActions = require("../../redux/futures/actions/futuresPositionsActions");
var _hooks = require("../OrderEntryComponents/hooks");
var _useEstimatedTPSLValues = _interopRequireDefault(require("./useEstimatedTPSLValues"));
var _useValidators2 = require("../../constants/useValidators");
require("./FuturesAddEditTPSLModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('add-edit-tpsl-modal');
var FUTURES_ADD_EDIT_TPSL_FORM = 'futuresAddEditTPSL';
var formatMoney = function formatMoney(value, symbol) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _numberFormatter.formatNumberToLocale)(value, symbol), /*#__PURE__*/_react["default"].createElement("span", {
    className: "-currency"
  }, " ", symbol));
};
var FuturesAddEditTPSLModal = function FuturesAddEditTPSLModal(props) {
  var _position$instrument, _position$quoteProduc, _position$quoteProduc2, _position$instrument2, _position$quoteProduc3, _position$quoteProduc4;
  var isOpen = props.isOpen,
    close = props.close,
    handleSubmit = props.handleSubmit,
    position = props.position,
    mode = props.mode,
    pristine = props.pristine,
    invalid = props.invalid,
    initialize = props.initialize,
    submitting = props.submitting;
  var _useTranslation = (0, _reactI18next.useTranslation)('futures'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var formValues = (0, _hooks.useFormValues)(FUTURES_ADD_EDIT_TPSL_FORM);
  var _useValidators = (0, _useValidators2.useValidators)(),
    validateFuturesTakeProfit = _useValidators.validateFuturesTakeProfit,
    getTakeProfitWarning = _useValidators.getTakeProfitWarning,
    validateFuturesStopLoss = _useValidators.validateFuturesStopLoss,
    getStopLossWarning = _useValidators.getStopLossWarning;
  var _useEstimatedTPSLValu = (0, _useEstimatedTPSLValues["default"])({
      takeProfit: formValues === null || formValues === void 0 ? void 0 : formValues.takeProfit,
      stopLoss: formValues === null || formValues === void 0 ? void 0 : formValues.stopLoss,
      amount: position === null || position === void 0 ? void 0 : position.PositionSize,
      side: position === null || position === void 0 ? void 0 : position.PositionType,
      price: position === null || position === void 0 ? void 0 : position.EntryPrice,
      instrument: position === null || position === void 0 ? void 0 : position.instrument
    }),
    estimatedProfitValue = _useEstimatedTPSLValu.estimatedProfitValue,
    estimatedLossValue = _useEstimatedTPSLValu.estimatedLossValue;
  var takeProfitValidator = (0, _react.useMemo)(function () {
    return validateFuturesTakeProfit(position === null || position === void 0 ? void 0 : position.MarkPrice, position === null || position === void 0 ? void 0 : position.PositionType);
  }, [validateFuturesTakeProfit, position === null || position === void 0 ? void 0 : position.MarkPrice, position === null || position === void 0 ? void 0 : position.PositionType]);
  var stopLossValidator = (0, _react.useMemo)(function () {
    return validateFuturesStopLoss(position === null || position === void 0 ? void 0 : position.MarkPrice, position === null || position === void 0 ? void 0 : position.PositionType);
  }, [validateFuturesStopLoss, position === null || position === void 0 ? void 0 : position.MarkPrice, position === null || position === void 0 ? void 0 : position.PositionType]);
  var handleClose = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return dispatch((0, _reduxForm.reset)(FUTURES_ADD_EDIT_TPSL_FORM));
        case 1:
          _context.n = 2;
          return close();
        case 2:
          return _context.a(2);
      }
    }, _callee);
  })), [dispatch, close]);
  var onSubmit = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(values) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return dispatch((0, _futuresPositionsActions.takeProfitStopLoss)({
              AccountId: position.AccountId,
              PositionId: position.PositionId,
              InstrumentId: position.InstrumentId,
              TakeProfitStopLossMode: 'Full',
              // not sure how this is calculated yet. Required param
              PositionIndex: 'OneWay',
              // always this for now. Required param
              TakeProfitPrice: values.takeProfit,
              StopLossPrice: values.stopLoss,
              TakeProfitTriggerByType: 'LastPrice',
              StopLossTriggerByType: 'LastPrice'
            }));
          case 1:
            _context2.n = 2;
            return handleClose();
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [dispatch, position, handleClose]);
  var isDisabled = pristine || invalid || mode === 'Add' && !formValues.stopLoss && !formValues.takeProfit;
  (0, _react.useEffect)(function () {
    if (isOpen && mode === 'Edit' && (position !== null && position !== void 0 && position.TakeProfit || position !== null && position !== void 0 && position.StopLoss)) {
      initialize({
        takeProfit: position.TakeProfit,
        stopLoss: position.StopLoss
      });
    } else if (isOpen && mode === 'Add') {
      initialize({
        takeProfit: '',
        stopLoss: ''
      });
    }
  }, [initialize, position, isOpen, mode]);
  if (!isOpen || !position) return null;
  var summaryColumns = [{
    header: t('Entry Price'),
    id: 'entryPrice',
    cell: function cell(_ref3) {
      var row = _ref3.row;
      return formatMoney(row.original.EntryPrice, row.original.QuoteProductSymbol);
    },
    meta: {
      textAlign: 'left'
    }
  }, {
    header: t('Size'),
    id: 'size',
    cell: function cell(_ref4) {
      var row = _ref4.row;
      return formatMoney(row.original.PositionSize, row.original.BaseProductSymbol);
    },
    meta: {
      textAlign: 'left'
    }
  }, {
    header: t('Last Price'),
    id: 'lastPrice',
    cell: function cell(_ref5) {
      var row = _ref5.row;
      return formatMoney(row.original.MarkPrice, row.original.QuoteProductSymbol);
    },
    meta: {
      textAlign: 'left'
    }
  }, {
    header: t('Liquidation Price'),
    id: 'liqPrice',
    cell: function cell(_ref6) {
      var row = _ref6.row;
      return formatMoney(row.original.LiquidationPrice, row.original.QuoteProductSymbol);
    },
    meta: {
      textAlign: 'left'
    }
  }];
  var summaryData = [{
    EntryPrice: position.EntryPrice,
    PositionSize: position.PositionSize,
    MarkPrice: position.MarkPrice,
    LiquidationPrice: position.LiquidationPrice,
    QuoteProductSymbol: position.QuoteProductSymbol,
    BaseProductSymbol: position.BaseProductSymbol
  }];
  var title = mode === 'Add' ? t('Add TP/SL') : t('Edit TP/SL');
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: title,
    onCancel: handleClose,
    close: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_table.Table, {
    columns: summaryColumns,
    data: summaryData,
    className: "futures-tpsl-summary-table",
    pagination: false
  }), /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit(onSubmit),
    className: "futures-tpsl-modal-form"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    component: _NumberInput.MoneyInputWithSlots,
    suffix: /*#__PURE__*/_react["default"].createElement("span", {
      className: bemClasses('suffix-label')
    }, t('Last')),
    name: "takeProfit",
    size: "small",
    placeholder: "0",
    label: t('Take Profit', {
      ns: 'order'
    }),
    infoText: /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('info-text-container')
    }, getTakeProfitWarning(formValues === null || formValues === void 0 ? void 0 : formValues.takeProfit) && /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('warning-message')
    }, getTakeProfitWarning(formValues === null || formValues === void 0 ? void 0 : formValues.takeProfit)), /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('estimated-info')
    }, t('Estimated Profit', {
      ns: 'order'
    }), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      className: "estimated-amount"
    }, estimatedProfitValue, " ", position === null || position === void 0 || (_position$instrument = position.instrument) === null || _position$instrument === void 0 ? void 0 : _position$instrument.Product2Symbol))),
    validate: [takeProfitValidator],
    symbol: position.QuoteProductSymbol,
    decimalPlaces: (_position$quoteProduc = (_position$quoteProduc2 = position.quoteProduct) === null || _position$quoteProduc2 === void 0 ? void 0 : _position$quoteProduc2.DecimalPlaces) !== null && _position$quoteProduc !== void 0 ? _position$quoteProduc : 2
  }), /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    component: _NumberInput.MoneyInputWithSlots,
    suffix: /*#__PURE__*/_react["default"].createElement("span", {
      className: bemClasses('suffix-label')
    }, t('Last')),
    name: "stopLoss",
    size: "small",
    placeholder: "0",
    label: t('Stop Loss', {
      ns: 'order'
    }),
    infoText: /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('info-text-container')
    }, getStopLossWarning(formValues === null || formValues === void 0 ? void 0 : formValues.stopLoss) && /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('warning-message')
    }, getStopLossWarning(formValues === null || formValues === void 0 ? void 0 : formValues.stopLoss)), /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('estimated-info')
    }, t('Estimated Loss', {
      ns: 'order'
    }), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      className: "estimated-amount"
    }, estimatedLossValue, " ", position === null || position === void 0 || (_position$instrument2 = position.instrument) === null || _position$instrument2 === void 0 ? void 0 : _position$instrument2.Product2Symbol))),
    validate: [stopLossValidator],
    symbol: position.QuoteProductSymbol,
    decimalPlaces: (_position$quoteProduc3 = (_position$quoteProduc4 = position.quoteProduct) === null || _position$quoteProduc4 === void 0 ? void 0 : _position$quoteProduc4.DecimalPlaces) !== null && _position$quoteProduc3 !== void 0 ? _position$quoteProduc3 : 2
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('buttons')
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    type: "submit",
    variant: "primary",
    disabled: isDisabled || submitting
  }, submitting ? t('Submitting...', {
    ns: 'core'
  }) : t('Confirm')))));
};
FuturesAddEditTPSLModal.propTypes = {
  isOpen: _propTypes["default"].bool,
  close: _propTypes["default"].func,
  handleSubmit: _propTypes["default"].func.isRequired,
  position: _propTypes["default"].object,
  mode: _propTypes["default"].string.isRequired,
  invalid: _propTypes["default"].bool.isRequired
};
FuturesAddEditTPSLModal.defaultProps = {
  isOpen: false,
  close: function close() {},
  position: null
};
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: FUTURES_ADD_EDIT_TPSL_FORM
})((0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.FUTURES_ADD_EDIT_TPSL
})(FuturesAddEditTPSLModal));